import styled from 'styled-components';

export default styled.ol`
  padding-left: 1rem;
  margin: 0;

  li + li {
    margin-top: 1rem;
  }
`;
